export default __webpack_public_path__ + "static/media/priya-prem-new.b9ebaab6.jpg";